import { api } from "@api/api";

export interface PlaygroundField {
  key: string;
  label?: string;
  required?: boolean;
  default?: string;
  prefix?: string;
  from_access_token?: boolean;
  value?: string;
}

export interface PlaygroundEndpoint {
  id: string;
  label: string;
  description: string;
  method: string;
  path: string;
  query: PlaygroundField[];
  headers: PlaygroundField[];
  body: PlaygroundField[];
  body_encoding: string;
}

export interface PlaygroundCatalog {
  catalog_key: string;
  catalog_label: string;
  integration: { id: number; name: string };
  agreement_id: number | null;
  auth_endpoint_id: string | null;
  auth_token_response_key: string;
  credentials: Record<string, string | number | boolean>;
  credential_schema: Array<{
    key: string;
    label?: string;
    type?: string;
    required?: boolean;
  }>;
  endpoints: PlaygroundEndpoint[];
}

export interface PlaygroundRunPayload {
  integration: number;
  agreement: number;
  endpoint_id: string;
  credentials: Record<string, string>;
  query: Record<string, string>;
  headers: Record<string, string>;
  body: Record<string, string> | null;
}

export interface PlaygroundResult {
  endpoint_id: string;
  method: string;
  body_encoding: string;
  url: string;
  status_code: number;
  elapsed_ms: number;
  headers: Record<string, string>;
  body: unknown;
  body_text: string;
  truncated: boolean;
  curl: string;
}

export async function getPlaygroundCatalog(
  integration: number,
  agreement: number
): Promise<PlaygroundCatalog> {
  const { data } = await api.get<PlaygroundCatalog>("/v1/integration_playground_admin/", {
    params: { integration, agreement },
  });
  return data;
}

export async function runPlayground(payload: PlaygroundRunPayload): Promise<PlaygroundResult> {
  const { data } = await api.post<PlaygroundResult>("/v1/integration_playground_admin/", payload);
  return data;
}
